import { render, staticRenderFns } from "./Shebei.vue?vue&type=template&id=53bc66ff"
import script from "./Shebei.vue?vue&type=script&lang=js"
export * from "./Shebei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports